export default "skymp5-front/dcfe4e251b91d9cbdcb53dadfb4879ef.webp";